import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi'

import { FooterOverlay, Newsletter } from '../../components'

import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className='app__footer section__padding'>
    <FooterOverlay />
    <Newsletter />

    <div className='app__footer-links'>
      <div className='app__footer-links_contact'>
        <h1 className='app__footer-headtext'>Contact Us</h1>
        <p className='p__opensans'>H: M-19/2, R: 04, West Merul, Badda, Dhaka-1212</p>
        <p className='p__opensans'>+1 215-986-7451</p>
        <p className='p__opensans'>+1 823-317-0328</p>
      </div>

      <div className='app__footer-links_logo'>
        <img src={images.gericht} alt="gericht" />
        <p className='p__opensans'>Contrary To Popular Belief, Lorem Ipsum Is Not Simply Random Text</p>
        <img src={images.spoon} alt="spoon" className='spoon__img' style={{ marginTop: 15 }} />
        <div className='app__footer-links_icons'>
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>

      <div className='app__footer-links_work'>
        <h1 className='app__footer-headtext'>Working Hours</h1>
        <p className='p__opensans'>Monday - Friday:</p>
        <p className='p__opensans'>08:00 am - 09:00 pm</p>
        <p className='p__opensans'>Saturday - Sunday:</p>
        <p className='p__opensans'>07:00 am - 11:00 pm</p>
      </div>
    </div>

    <div className='footer__copyright'>
      <p className='p__opensans'>All right reserved by @Nazmul 2022</p>
    </div>
  </div>
);

export default Footer;
